// @flow

import React from 'react';
import classNames from 'classnames/bind';
import TableMessage from '../table-message';
import style from './style.css';

type Props = {
  +title: string,
  +description: string
};

const cx = classNames.bind(style);
const stylePrefix = 'disputes-empty-message';

const EmptyMessage = ({title, description}: Props) => (
  <TableMessage>
    <div className={cx(stylePrefix)}>
      <div className={cx(`${stylePrefix}__title`)}>{title}</div>
      <div className={cx(`${stylePrefix}__description--fade`)}>{description}</div>
    </div>
  </TableMessage>
);

export default EmptyMessage;
